import React from 'react'


export default function Index(props) {
  return (
    <div className="assessment1-container">
      <div className="assessment1-title">
        Directions
      </div>
      <div className="assessment1-content">
        During dinner, all of your guests realize they need to use the bathroom at the same time. Because each guest has forgotten the location of their table, your job is to point them in the right direction.  To do so, you need to identify whether the guest you encounter is one of your guests  or is sitting at another table.  Click "Get started" to test your ability to recognize faces!
      </div>
      <div className="assessment1-wrap">
        <div onClick={() => props.nextPage()} className="assessment1-start-btn">
          Get started
        </div>
      </div>
    </div>
  )
}
